import Cookies from 'js-cookie';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useBoolean } from '@sravni/react-utils';

import { SravniIdentitySubscriptionType } from '../__generated__/news/Api';
import { makeMainGEvent, pushEvent } from '../helpers/analytics';
import { fetchUserSubscriptions } from '../reducers/user';
import { subscribeNewsUser } from '../services/subscription';

import { useUser, useUserSubscriptions } from './users';

export const useSubscription = (
  place: string,
  onSuccessSubscription?: () => void,
  onFailSubscription?: () => void,
): {
  userEmail?: string;
  handleSubscriptionClick: (email: string) => Promise<void>;
  canUserSubscribe: boolean;
  isEmailEditable: boolean;
  didUserSubscribe: boolean;
  isSubscribing: boolean;
} => {
  const dispatch = useDispatch();
  const user = useUser();
  const userSubscriptions = useUserSubscriptions();
  const gaId = Cookies.get('_ga');
  const [didUserSubscribe, setUserSubscribed] = useBoolean(false);
  const [isSubscribing, setSubscribingProcess] = useBoolean(false);

  useEffect(() => {
    if (user) {
      dispatch(fetchUserSubscriptions());
    }
  }, [user, dispatch]);

  const doesUserSubscribeToNews = user && userSubscriptions?.includes(SravniIdentitySubscriptionType.News);

  const successCallback = () => {
    pushEvent(
      makeMainGEvent({
        eventCategory: 'Контент',
        eventAction: 'Подписка на рассылку',
        eventLabel: place,
        eventValue: undefined,
      }),
    );
    window.open('/promo/thanks-for-subscribing/');
    onSuccessSubscription && onSuccessSubscription();
  };

  const handleSubscriptionClick = async (email?: string) => {
    setSubscribingProcess.on();
    setUserSubscribed.off();
    try {
      await subscribeNewsUser({ email });
      setUserSubscribed.on();
      successCallback && successCallback();
    } catch (error) {
      console.error(error.response.data.message);
      setUserSubscribed.off();
      onFailSubscription && onFailSubscription();
    }
    setSubscribingProcess.off();
  };

  const isEmailEditable = !Boolean(user?.email_verified) || !user?.email;
  const canUserSubscribe = gaId && !doesUserSubscribeToNews;

  return {
    userEmail: user?.email,
    isEmailEditable,
    handleSubscriptionClick,
    canUserSubscribe,
    didUserSubscribe,
    isSubscribing,
  };
};
